import React, { useEffect, useState } from 'react';

import SsnBannerXl from '../../assets/banner_xl.svg';
import SsnBannerSm from '../../assets/banner_sm.svg';
import DesktopBanner from '../../assets/broadband_desktop_banner.png'

interface SsnBroadbandBannerProps {}

const SsnBroadbandBanner = ({}: SsnBroadbandBannerProps) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <img src={screenWidth < 768 ? SsnBannerSm : DesktopBanner} alt="SSN Broadband Banner" />
    </>
  );
};

export default SsnBroadbandBanner;
